import React, { useEffect, useState } from 'react';

import FakePhone from '@components/fakePhone/FakePhone';
import FakePhoneAppSwitcher from '@components/fakePhone/FakePhoneAppSwitcher';
import { useAppDispatch, useAppSelector } from '@core/hooks/appHooks';
import useDetectedChangesBlocker from '@core/hooks/useUnsavedChanges';
import { NetworkService } from '@core/services/networkService/networkService';
import { selectVendor, setVendor } from '@core/store/appSlice/appSlice';
import DemmiButton from '@demmi-ui/Button';
import { demmiRequest } from '@helpers/app.helper';
import { ThemeHelper } from '@helpers/theme.helper';
import { DemmiFS } from '@subhanhabib/demmilib';

import ShopManagementThemeHues from './_hues';

const ShopManagementTheme: React.FC = () => {
  const CSSBlock = 'shop-management-theme';
  const dispatch = useAppDispatch();
  const vendor = useAppSelector(selectVendor);
  const [app, setApp] = useState(0);

  const [hue, setHue] = useState(-1);
  const [detectedChanges, setDetectedChanges] = useState(false);

  useDetectedChangesBlocker({
    detectedChanges,
  });

  const setValues = (vendor: DemmiFS.Vendor) => {
    setHue(vendor.themeHue);
    ThemeHelper.setCSSVar(
      ThemeHelper.CSSVARS.PHONE_PREVIEW_HUE,
      vendor.themeHue.toString(),
    );
    ThemeHelper.setCSSPhonePreviewPalette(
      ThemeHelper.DemmiTheme.get(vendor.themeHue).palette,
    );
  };

  useEffect(() => {
    if (vendor) setValues(vendor);
  }, [vendor]);

  useEffect(() => {
    setDetectedChanges(hue !== vendor?.themeHue);
  }, [hue]);

  const discardChanges = () => {
    if (vendor) setValues(vendor);
  };

  const saveChanges = async () => {
    if (vendor) {
      const f: DemmiFS.Vendor = {
        ...vendor,
        themeHue: hue,
      };
      demmiRequest(NetworkService.Vendors.updateVendorTheme(f)).then(() =>
        dispatch(setVendor(f)),
      );
    }
  };

  const onHueChange = (hue: number) => {
    ThemeHelper.setCSSPhonePreviewPalette(
      ThemeHelper.DemmiTheme.get(hue).palette,
    );
    setHue(hue);
  };

  return (
    <div className={`${CSSBlock}`}>
      <FakePhone hue={hue} app={app} />
      <FakePhoneAppSwitcher app={app} setApp={setApp} />
      <ShopManagementThemeHues onHueChange={onHueChange} />

      <div className={`${CSSBlock}__buttons`}>
        <DemmiButton
          text={'Discard Changes'}
          faIcon="fa-ban"
          disabled={!detectedChanges}
          onClick={() => discardChanges()}
        />
        <DemmiButton
          text={'Save Changes'}
          faIcon="fa-regular fa-floppy-disk"
          disabled={!detectedChanges}
          onClick={() => saveChanges()}
        />
      </div>
    </div>
  );
};

export default ShopManagementTheme;
